<template>
  <scout-form
    :is-modified="!!value.length"
    :label="`${prefix}雇用形態`"
  >
    <div class="boss-layout boss-layout-start boss-layout-wrap boss-layout-gap-large">
      <div
        v-for="option in employmentStatusMaster"
        :key="option.id"
      >
        <label
          :data-test="`label-${option.id}`"
          class="boss-checkbox"
        >
          <input
            :value="option.id"
            :checked="value.includes(option.id)"
            :data-test="`checkbox-${option.id}`"
            type="checkbox"
            class="boss-input-checkbox"
            @change="onChange"
          >{{ option.name }}
        </label>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ScoutForm
  },
  props: {
    prefix: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: Array
    }
  },
  computed: {
    ...mapGetters([
      'employmentStatusMaster'
    ])
  },
  methods: {
    onChange ($event) {
      if ($event.target.checked) {
        this.$emit('input', [...this.value, $event.target._value].sort())
      } else {
        this.$emit('input', _.without(this.value, $event.target._value))
      }
    }
  }
}
</script>
